import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "@/components/SEO";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO title="Page not found" description="404" path="/404" noindex />
      <section className="mx-auto max-w-[1240px] px-6 lg:px-10 py-24 lg:py-32" data-testid="notfound-page">
        <p className="font-heading text-7xl sm:text-8xl font-semibold text-[var(--navy)] tracking-tight">
          {t("notfound.code")}
        </p>
        <h1 className="mt-6 font-heading text-3xl sm:text-4xl font-semibold text-[var(--navy)]">
          {t("notfound.title")}
        </h1>
        <p className="mt-4 text-base text-[var(--slate)] max-w-xl">
          {t("notfound.body")}
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/" className="btn-primary text-sm" data-testid="notfound-home">
            {t("notfound.home")}
          </Link>
          <Link to="/products/blister-pack-violet-ink" className="btn-outline text-sm" data-testid="notfound-products">
            {t("notfound.products")}
          </Link>
          <Link to="/contact" className="btn-ghost text-sm" data-testid="notfound-contact">
            {t("notfound.contact")}
          </Link>
        </div>
      </section>
    </>
  );
};

export default NotFound;
